export default __webpack_public_path__ + "static/media/MASCOT DISDIK 7-04.af3f6ca9.png";